import { NgModule, } from '@angular/core';
//import { CommonModule } from '@angular/common';
//import { FormsModule } from '@angular/forms';

import { JkBDbService } from './services/jkBdb';
import { LoginService } from './services/jkUser';
import { Preference } from './services/preference';
import { OrmService } from './services/jkOrm';
import { PageService } from './services/page.service';
import { HttpClient } from '@angular/common/http';
import { AgGridService } from './services/ag-grid.service';
import { JkExcelService } from './services/jkexcel.service';
import { JkCatchOpenWin } from './services/jkCatchOpenWin';


import { JkfieldlabelComponent } from './components/jkfieldlabel/jkfieldlabel.component';
import { JkeditComponent } from './components/jkedit/jkedit.component';
import { JkBaseComponent } from './components/jkbase/jkbase.component';



import { JkcheckboxYNComponent } from './components/jkcheckbox/jkcheckboxYN.component';
import { JkComboboxNComponent } from './components/jkcombobox/jkcomboboxN.component';
import { JkdownloadFileComponent } from './components/jkdownload/jkdownload.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { CrudbarComponent } from './components/crudbar/crudbar.component';
import { CrudbarNavComponent } from './components/crudbar-nav/crudbar-nav.component';
import { JkaboutComponent, } from './components/jkabout/jkabout.component';
//import { JkbtneditComponent } from './components/jkbtnedit/jkbtnedit.component';
import { JkcheckboxComponent } from './components/jkcheckbox/jkcheckbox.component';
import { JkComboboxComponent } from './components/jkcombobox/jkcombobox.component';
import { JkdatefieldComponent } from './components/jkdatefield/jkdatefield.component';
import { JkdaterangeComponent } from './components/jkdaterange/jkdaterange.component';
import { JkfabButtonComponent } from './components/jkfab-button/jkfab-button.component';
import { JkloadingComponent } from './components/jkloading/jkloading.component';
import { JklookupComponent } from './components/jklookup/jklookup.component';
//import { JkmultiselectComponent } from './components/jkmultiselect/jkmultiselect.component';
import { JkradiogroupComponent } from './components/jkradiogroup/jkradiogroup.component';
//import { JkrangeComponent } from './components/jkrange/jkrange.component';
import { JkstarmarkComponent } from './components/jkstarmark/jkstarmark.component';
import { JkswitchComponent } from './components/jkswitch/jkswitch.component';
import { JktagboxComponent } from './components/jktagbox/jktagbox.component';
import { JktextareaComponent } from './components/jktextarea/jktextarea.component';
import { JktextComponent } from './components/jktext/jktext.component';
import { ModalHeaderComponent } from './components/modal-header/modal-header.component';
import { TitlebarComponent } from './components/titlebar/titlebar.component';
import { JkbuttongroupComponent } from './components/jkbuttongroup/jkbuttongroup.component';
import { JkautocompleteComponent } from './components/jkautocomplete/jkautocomplete.component';
import { JkqbeComponent } from './components/jkqbe/jkqbe.component';
import { JknumbereditComponent } from './components/number-edit/number-edit.component';
import {
  AgHtmlCellRenderer, AgStockQuoteCellView, AgTextAreaEditor, AgTextAreaEditorFix,
  AgCheckBoxEditor, AgComboBoxEditor, FullWidthCellRenderer, BtnEditCellRendererComponent, BtnDeleteCellRendererComponent,
  CustomButtonComponent, AgNumberEditor, AgPercentEditor, DoublingEditor,
} from './components/ag-cell/ag-cell.component';
//import { JkgridwinComponent } from './components/jkgridwin/jkgridwin.component';
//import { JkaggridComponent } from './components/jkaggrid/jkaggrid.component';
//import { AgOpenwinComponent } from './components/agopenwin/agopenwin.component';
import { CrudbarDataSetComponent } from './components/crudbar-ds/crudbar-ds.component';
import { JkPopupTextareaComponent } from './components/jk-popup-textarea/jk-popup-textarea.component';
import { JkimageComponent, Orientation } from './components/jkimage/jkimage.component';
import { JklistComponent } from './components/jklist/jklist.component';
import { JksliderComponent } from './components/jkslider/jkslider.component';
import { JktableComponent } from './components/jktable/jktable.component';
import { MqttSpeakerComponent } from './components/mqtt-speaker/mqtt-speaker.component';
import { quillEditorOptions, QuillHtmlComponent } from './components/quill-html/quill-html.component';
import { MarkdownComponent } from './components/quill-html/markdown.component';
import { JkDialogEditComponent } from './components/jkDialogEdit';
import { PullToRefreshComponent } from './components/pullToRefresh/pull-to-refresh.component';
import { HomeBottomComponent } from './components/home-bottom/home-bottom.component';
import { HomeHeaderComponent } from './components/home-header/home-header.component';
import { JkTranslateComponent } from './components/jk-translate/jk-translate.component';
import { FileUploadMode, UploadHttpMethod, JkuploadComponent } from './components/jkupload/jkupload.component';
//import { SpeechAlarmComponent } from './components/speech-alarm/speech-alarm.component';
import { LoginFormPage } from './components/login-form/login-form.component';
import { Error404Component } from './components/error404/error404.component';
//import { JkTabEditComponent } from './components/jkTabEdit';
import { JkmenuComponent } from './components/jkmenu/jkmenu.component';
import { AccelerometerComponent } from './components/acceleration.component';
import { jkBaseForm } from './components/jkBaseForm';

export { Orientation } from './components/jkimage/jkimage.component';
export { quillEditorOptions } from './components/quill-html/quill-html.component';
export { FileUploadMode, UploadHttpMethod } from './components/jkupload/jkupload.component';


@NgModule(
  {
    providers: [
      HttpClient, JkBDbService, LoginService, Preference, OrmService, PageService,
      AgGridService, JkExcelService, JkCatchOpenWin,
    ],
    imports: [
      //CommonModule,
      //FormsModule,
      //MatDialogModule,
      //BrowserModule,
      ConfirmDialogComponent, CrudbarComponent, CrudbarNavComponent,
      //CrudbarDataSetComponent,HomeHeaderComponent,TeaTimerComponent,WeatherWidgetComponent,
      // JkgridwinComponent,      JkaggridComponent,AgOpenwinComponent,JkrangeComponent,
      JkaboutComponent,
      //JkbtneditComponent,JkmultiselectComponent,SpeechAlarmComponent,
      JkcheckboxComponent, JkcheckboxYNComponent,
      JkComboboxComponent, JkComboboxNComponent, JkdaterangeComponent, JkdownloadFileComponent, JkfabButtonComponent,
      JkloadingComponent, JktextComponent, JktextareaComponent, ModalHeaderComponent,
      TitlebarComponent,


      JkstarmarkComponent,

      JklookupComponent, JkdatefieldComponent, JktagboxComponent,
      JknumbereditComponent,
      JkswitchComponent,
      JkautocompleteComponent,
      //JkautocompleteAsyncComponent,
      JkradiogroupComponent,
      JkbuttongroupComponent,
      JkqbeComponent,
      //AngularSplitModule,
      AgHtmlCellRenderer, AgStockQuoteCellView, AgTextAreaEditor, AgTextAreaEditorFix,
      AgCheckBoxEditor, AgComboBoxEditor, FullWidthCellRenderer, BtnEditCellRendererComponent, BtnDeleteCellRendererComponent,
      CustomButtonComponent, AgNumberEditor, AgPercentEditor, DoublingEditor,
      CrudbarDataSetComponent, JkPopupTextareaComponent, JkimageComponent,
      JklistComponent, JksliderComponent, JktableComponent, MqttSpeakerComponent,
      QuillHtmlComponent, MarkdownComponent, JkDialogEditComponent, PullToRefreshComponent,
      HomeBottomComponent, HomeHeaderComponent, JkTranslateComponent, JkuploadComponent,
      LoginFormPage, Error404Component,
      //JkTabEditComponent,
      JkBaseComponent, JkfieldlabelComponent, JkeditComponent,
      JkmenuComponent, AccelerometerComponent, jkBaseForm,

    ],
    declarations: [
      //AutoResizeDirective, // 声明 Directive
    ],
    exports: [
      JkBaseComponent, JkfieldlabelComponent, JkeditComponent,
      ConfirmDialogComponent, CrudbarComponent, CrudbarNavComponent,
      //CrudbarDataSetComponent,TeaTimerComponent,WeatherWidgetComponent,SpeechAlarmComponent,
      JkaboutComponent,
      //JkbtneditComponent,JkmultiselectComponent,JkgridwinComponent, JkaggridComponent,AgOpenwinComponent,JkrangeComponent,

      JkcheckboxComponent, JkcheckboxYNComponent,
      JkComboboxComponent, JkComboboxNComponent, JkdaterangeComponent, JkdownloadFileComponent, JkfabButtonComponent,
      JkloadingComponent, JktextComponent, JktextareaComponent, ModalHeaderComponent,
      TitlebarComponent,
      JknumbereditComponent,
      JkstarmarkComponent,

      JklookupComponent, JkdatefieldComponent, JktagboxComponent,
      JkswitchComponent,
      JkautocompleteComponent,
      //JkautocompleteAsyncComponent,
      JkradiogroupComponent,
      JkbuttongroupComponent,
      JkqbeComponent,
      //AngularSplitModule,
      AgHtmlCellRenderer, AgStockQuoteCellView, AgTextAreaEditor, AgTextAreaEditorFix,
      AgCheckBoxEditor, AgComboBoxEditor, FullWidthCellRenderer, BtnEditCellRendererComponent, BtnDeleteCellRendererComponent,
      CustomButtonComponent, AgNumberEditor, AgPercentEditor, DoublingEditor,
      CrudbarDataSetComponent, JkPopupTextareaComponent, JkimageComponent,
      JklistComponent, JksliderComponent, JktableComponent, MqttSpeakerComponent,
      QuillHtmlComponent, MarkdownComponent, JkDialogEditComponent, PullToRefreshComponent,
      HomeBottomComponent, HomeHeaderComponent, JkTranslateComponent, JkuploadComponent,
      LoginFormPage, Error404Component,
      // JkTabEditComponent,
      JkmenuComponent, AccelerometerComponent, jkBaseForm,

    ]

  })
export class JackBaseComponentModule { } // 暫時不要 export.容易循環引用

